<div class="row title">
  <h3>Dashboard / <span>Designer List</span></h3>
</div>

<div class="marginTop row">
	<!-- <div class="col-12" *ngIf="erroralert">
		<div class="alert-box grid-100" *ngIf="errorMessage">
			<div class="alert alert-danger mt-3 text-center">
				<a class="close link" data-dismiss="alert" (click)="erroralert=false">×</a>
				{{errorMessage}}
			</div>
		</div>
	</div>
	<div class="col-12" *ngIf="successalert">
		<div class="alert-box grid-100" *ngIf="successMessage">
			<div class="alert alert-success mt-3 text-center">
				<a class="close link" data-dismiss="alert"  (click)="successalert=false">×</a>
				{{successMessage}}
			</div>
		</div>
	</div> -->
</div>

<div class="row body_height" *ngIf="listDesigners">
	<div class="col-12 table-responsive p-0">
		<table class="table table-hover">
			<thead>
				<tr>
					<th>Serial No.</th>
					<th>Designer Name</th>
					<th>Designer Email</th>
					<th>Contact</th>
					<th class="text-center">Action</th>
				</tr>
			</thead>
			<tbody>
				<tr *ngFor="let designer of listDesigners.users; let i = index; ">
					<td>{{i+1}}</td>
					<td class="capitalize">{{designer.name}}</td>
					<td>{{designer.email}}</td>
					<td>{{designer.contact}}</td>
					<td class="text-center"><a [routerLink]="['/project-list-of_designer/'+designer.id]" [queryParams]="{'designer_name':designer.name}">View Projects</a></td>
				</tr>
			</tbody>
		</table>
	</div>
</div>


// WEBPACK FOOTER //
// ./src/app/platform/organisation/cm-dashboard/list-designer/list-designer.component.html